import { render, staticRenderFns } from "./Vcareer.vue?vue&type=template&id=1bc4492f"
import script from "./Vcareer.vue?vue&type=script&lang=js"
export * from "./Vcareer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports